import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ChevronRightOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { TextDynamic, Text } from '@hh.ru/magritte-ui-typography';
import { s as styles } from './styles-BqvkUtIq.js';

const CellRightLabel = ({ style = 'secondary', iconInitial = 'secondary', iconDisabled = 'secondary', iconHighlighted = 'secondary', badge, hideIcon = false, 'data-qa': dataQa = 'cell-chevron', children, }) => {
    return (jsxs("div", { className: styles.label, "data-qa": dataQa, children: [children && (jsx(TextDynamic, { children: jsx(Text, { style: style, typography: "label-2-regular", children: children }) })), badge && jsx("div", { className: styles.item, children: badge }), !hideIcon && (jsx("div", { className: styles.item, children: jsx(ChevronRightOutlinedSize24, { initialColor: iconInitial, highlightedColor: iconHighlighted, disabledColor: iconDisabled }) }))] }));
};

export { CellRightLabel };
//# sourceMappingURL=CellRightLabel.js.map
